import DatePicker from 'components/form/DatePicker';
import TextInput from 'components/form/TextInput';
import React from 'react';

// "Full Paper Follow-Up Email"
const EigthStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur } = props;
  const {
    conference_short_name,
    client_name,
    conference_from_date,
    conference_to_date,
    conference_location,
    submission_date_line,
    guideline,
    submission_full_paper,
    contact_support,
    your_name,
    your_title,
    your_contact_information,
    your_website,
  } = values;
  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={
              touched.conference_short_name && errors.conference_short_name
            }
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference From Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_from_date"
            onChange={handleChange}
            value={conference_from_date}
            disabled={!isEdit}
            error={errors.conference_from_date}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference To Date
        </div>
        <div className="col-lg-6">
          <DatePicker
            id="conference_to_date"
            onChange={handleChange}
            value={conference_to_date}
            disabled={!isEdit}
            error={errors.conference_to_date}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">Venue</div>
        <div className="col-lg-6">
          <TextInput
            id="conference_location"
            onChange={handleChange}
            value={conference_location}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_location && errors.conference_location}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Guidelines
        </div>
        <div className="col-lg-6">
          {/* disabled={!isEdit} */}
          <TextInput
            id="guideline"
            onChange={handleChange}
            value={guideline}
            disabled={!isEdit}
            suggestions={suggestionData?.guideline}
            onBlur={handleBlur}
            error={touched.guideline && errors.guideline}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Submission Deadline
        </div>

        <div className="col-lg-6">
          <DatePicker
            id="submission_date_line"
            onChange={handleChange}
            value={submission_date_line}
            disabled={!isEdit}
            error={errors.submission_date_line}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Submit Full Paper
        </div>
        <div className="col-lg-6">
          <TextInput
            id="submission_full_paper"
            onChange={handleChange}
            value={submission_full_paper}
            disabled={!isEdit}
            suggestions={suggestionData?.submission_full_paper}
            onBlur={handleBlur}
            error={
              touched.submission_full_paper && errors.submission_full_paper
            }
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Contact Support
        </div>
        <div className="col-lg-6">
          <TextInput
            id="contact_support"
            onChange={handleChange}
            value={contact_support}
            disabled={!isEdit}
            suggestions={suggestionData?.contact_support}
            onBlur={handleBlur}
            error={touched.contact_support && errors.contact_support}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_name"
            onChange={handleChange}
            value={your_name}
            disabled={!isEdit}
            suggestions={suggestionData?.your_name}
            onBlur={handleBlur}
            error={touched.your_name && errors.your_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Title
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_title"
            onChange={handleChange}
            value={your_title}
            disabled={!isEdit}
            suggestions={suggestionData?.your_title}
            onBlur={handleBlur}
            error={touched.your_title && errors.your_title}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Contact Information
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_contact_information"
            onChange={handleChange}
            value={your_contact_information}
            disabled={!isEdit}
            suggestions={suggestionData?.your_contact_information}
            onBlur={handleBlur}
            error={
              touched.your_contact_information &&
              errors.your_contact_information
            }
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-20">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Your Website
        </div>
        <div className="col-lg-6">
          <TextInput
            id="your_website"
            onChange={handleChange}
            value={your_website}
            disabled={!isEdit}
            suggestions={suggestionData?.your_website}
            onBlur={handleBlur}
            error={touched.your_website && errors.your_website}
          />
        </div>
      </div>
    </>
  );
};

export default EigthStepOfFollowUps;
